import { reducer as form } from 'redux-form';
import onboard from './onboard';
import website from './website';
import wedding from './wedding';
import modal from './modal';
import auth from './auth';
import guestList from './guestList';
import user from './user';
import checklist from './checklist';
import publicWebsite from './public';
import collectAddress from './collectAddress';
import dashboard from './dashboard';
import moduleGroup from './moduleGroup';
import registry from './registry';
import registryCollections from './registryCollections';
import cart from './cart';
import feed from './feed';
import notifications from './notifications';
import external from './external';
import cache from './cache';
import events from './events';
import cards from '../cards/reducers';

export default {
  form,
  modal,
  Onboard: onboard,
  wedding,
  auth,
  website,
  guestList,
  user,
  checklist,
  publicWebsite,
  collectAddress,
  dashboard,
  moduleGroup,
  registry,
  registryCollections,
  cart,
  feed,
  notifications,
  external,
  cache,
  events,
  cards,
};



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/